// extracted by mini-css-extract-plugin
export default {"titlePlaceholder":"MainPageSkeleton_titlePlaceholder__9Qk83","textPlaceholder":"MainPageSkeleton_textPlaceholder__mjiaI"};